// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/callout-panel/callout-panel';
import 'sections/collection-list/collection-list-carousel';
import 'sections/collection-list/collection-list-carousel-tabs';
import 'sections/announcement-bar/announcement-bar';
import 'sections/banner/banner';
import 'sections/icons-with-text/icons-with-text';
import 'sections/image-with-text/image-with-text';
import 'sections/faq/faq';
import 'sections/pull-quote/pull-quote';
import 'sections/featured-collection/featured-collection-grid';
import 'sections/featured-collection-product/featured-collection-product';
import 'sections/multicolumn/multicolumn';
import 'sections/blog-posts/blog-posts-grid';
import 'sections/email-signup/email-signup';
import 'sections/footer/footer';

// Styles